export default __webpack_public_path__ + "static/media/fi-rr-lock1.6d2da6d0.svg";